import { Skeleton, Text } from '@consumidor-positivo/aurora';
import classNames from 'classnames';

import './styles.scss';

type MMCardSkeletonProps = {
  position: number;
};

export const MMCardSkeleton: React.FC<MMCardSkeletonProps> = ({ position }) => {
  const borderSkeleton = classNames('mm-card-skeleton', {
    'mm-card-skeleton--first': position === 1,
    'mm-card-skeleton--second': position === 2,
    'mm-card-skeleton--third': position === 3,
  });

  const stampClass = classNames('mm-card-skeleton__stamp', {
    'mm-card-skeleton__stamp--first': position === 1,
    'mm-card-skeleton__stamp--second': position === 2,
    'mm-card-skeleton__stamp--third': position === 3,
  });

  return (
    <div className={borderSkeleton}>
      {position <= 3 && (
        <div className={stampClass}>
          <Text as="h4" variant="heading-micro" className="mm-card-skeleton__number">
            {position}º
          </Text>
        </div>
      )}
      <div className="mm-card-skeleton__header">
        <Skeleton width={140} height={88} />
        <Skeleton width={160} height={24} shape="square" />
      </div>

      <div className="mm-card-skeleton__highlights">
        <Skeleton block height={26} />
        <Skeleton block height={26} />
      </div>

      <div className="mm-card-skeleton__description">
        <Skeleton block height={135} shape="square" />
      </div>

      <div className="mm-card-skeleton__footer">
        <Skeleton block height={48} shape="circle" />
      </div>
    </div>
  );
};
